import { useState, type HTMLAttributes } from 'react';

import type { FigmaBreakpoint } from '../../figma/useFigmaBreakpoint';
import './photo-card.css';

export interface PhotoCardProps extends Omit<HTMLAttributes<HTMLElement>, 'children'> {
  alt?: string;
  caption?: string;
  imageUrl?: string;
  size: FigmaBreakpoint;
  state?: 'Default' | 'empty';
}

const FIGMA_NODES: Record<FigmaBreakpoint, { default: string; hover: string }> = {
  '1920': { default: '65:31266', hover: '65:31274' },
  '1440': { default: '160:39155', hover: '160:39160' },
  '768': { default: '164:40078', hover: '164:40083' },
  '375': { default: '164:41579', hover: '164:41584' },
};

export function PhotoCard({
  alt = '',
  caption = '',
  className = '',
  imageUrl,
  onBlur,
  onFocus,
  onMouseEnter,
  onMouseLeave,
  size,
  state = 'Default',
  ...props
}: PhotoCardProps) {
  const [interactive, setInteractive] = useState(false);
  const nodes = FIGMA_NODES[size];
  const isEmpty = state === 'empty' || !imageUrl;

  return (
    <article
      {...props}
      className={[
        'lovo-photo-card',
        `lovo-photo-card--${size}`,
        isEmpty ? 'lovo-photo-card--empty' : '',
        className,
      ].filter(Boolean).join(' ')}
      data-figma-node={isEmpty ? '1:12036' : (interactive ? nodes.hover : nodes.default)}
      data-figma-variant={`State=${isEmpty ? 'empty' : (interactive ? 'hover' : 'Default')}, Size=${size}`}
      onBlur={(event) => {
        setInteractive(false);
        onBlur?.(event);
      }}
      onFocus={(event) => {
        setInteractive(true);
        onFocus?.(event);
      }}
      onMouseEnter={(event) => {
        setInteractive(true);
        onMouseEnter?.(event);
      }}
      onMouseLeave={(event) => {
        setInteractive(false);
        onMouseLeave?.(event);
      }}
      tabIndex={isEmpty ? -1 : 0}
    >
      {isEmpty ? (
        <div className="lovo-photo-card__empty-text">
          <p>Здесь скоро будут новые фото довольных питомцев ❤︎</p>
        </div>
      ) : (
        <>
          <img className="lovo-photo-card__image" src={imageUrl} alt={alt} />
          {caption ? (
            <div className="lovo-photo-card__footer">
              <p className="lovo-photo-card__caption">{caption}</p>
            </div>
          ) : null}
        </>
      )}
    </article>
  );
}
